import React from "react";

export const ButtonWithIcon = ({ icon, text, onClick, active, width, height, style }) => {
    return (
      <button onClick={onClick} style={{
        background: 'none',
        border: 'none',
        borderBottom: active ? '1px solid white' : 'none',
        ...style
      }}>
        <img src={icon} alt={text} style={{
           height: height,
           width: width,
        }} />
        {/* <div 
          className="text"
        style={{
          color: 'white',
        }}>{text}</div> */}
      </button>
    );
  };

    export default ButtonWithIcon;